// extracted by mini-css-extract-plugin
export default {"divider":"PopoverList_divider__4oUSr","item":"PopoverList_item__4kfsN","itemText":"PopoverList_itemText__sEm36","primary":"PopoverList_primary__5HVfI"};